export const HOUR_VALIDATOR = 'hour-validator';
async function hourValidator(hour) {
    let message = '';
    let valid = true;
    if (hour) {
        const regexHour = /^(?:2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]$/;
        const result = regexHour.exec(hour);
        if (!result) {
            message = 'tws.formatter.numeric.invalid';
            valid = false;
        }
    }
    return [{
            message,
            name: HOUR_VALIDATOR,
            valid
        }];
}
export default hourValidator;
//# sourceMappingURL=hour-validator.js.map